{{set divide = {flag:true} }}

<div class="mfunsPlayer-danmaku-set-mask">

  <div class="mfunsPlayer-controller-danmaku-settings-wrap mfunsPlayer-controller-panel">
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-danmaku-fps">fps: <div class="mfunsPlayer-danmaku-fps-value">0</div>
      </div>
      <div class="mfunsPlayer-danmaku-current-count">当前弹幕数：<div class="mfunsPlayer-danmaku-current-count-value">0</div>
      </div>
      <div class="mfunsPlayer-danmaku-count">弹幕总数：<div class="mfunsPlayer-danmaku-count-value">0</div>
      </div>
    </div>
    <div class="mfunsPlayer-set-item">
      <div class="mfunsPlayer-set-title">按类型屏蔽</div>
      <div class="mfunsPlayer-panel-row">
        <ul class="mfunsPlayer-picker mfunsPlayer-danmaku-filter-picker">
          <li class="picker-item" data-value="right">滚动</li>
          <li class="picker-item" data-value="top">顶部</li>
          <li class="picker-item" data-value="bottom">底部</li>
          <li class="picker-item" data-value="repeat">重复</li>
          <li class="picker-item" data-value="color">彩色</li>
          <li class="picker-item" data-value="advance">特殊</li>
        </ul>
      </div>
    </div>
    <div class="mfunsPlayer-set-item">
      <div class="mfunsPlayer-set-title">弹幕设置</div>
      <div class="mfunsPlayer-panel-row">
        <div class="row-title">不透明度</div>
        <div class="mfunsPlayer-danmaku-opacity-slider mfunsPlayer-slider">
          {{ include '../slider.art' }}
        </div>
        <div class="mfunsPlayer-danmaku-opacity-value row-value">-</div>
      </div>
      <div class="mfunsPlayer-panel-row">
        <div class="row-title">显示区域</div>
        <div class="mfunsPlayer-danmaku-showarea-slider mfunsPlayer-slider">
          {{ include '../slider.art' divide}}
          <ul class="slider-tip">
            <li class="slider-tip-item">1/4</li>
            <li class="slider-tip-item">3/4</li>
            <li class="slider-tip-item">不限</li>
          </ul>
        </div>
        <div class="mfunsPlayer-danmaku-showarea-value row-value">-</div>
      </div>
      <div class="mfunsPlayer-panel-row">
        <div class="row-title">文字大小</div>
        <div class="mfunsPlayer-danmaku-size-slider mfunsPlayer-slider">
          {{ include '../slider.art' }}
        </div>
        <div class="mfunsPlayer-danmaku-size-value row-value">-</div>
      </div>
      <div class="mfunsPlayer-panel-row">
        <div class="row-title">移动速度</div>
        <div class="mfunsPlayer-danmaku-speed-slider mfunsPlayer-slider">
          {{ include '../slider.art' divide}}
          <ul class="slider-tip">
            <li class="slider-tip-item">极慢</li>
            <li class="slider-tip-item">适中</li>
            <li class="slider-tip-item">极快</li>
          </ul>
        </div>
        <div class="mfunsPlayer-danmaku-speed-value row-value">-</div>
      </div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-danmaku-list-btn current">当前弹幕列表</div>
    </div>

  </div>
</div>

<div class="mfunsPlayer-danmaku-list-mask">
  <p>弹幕列表</p>
  <div class="mfunsPlayer-danmaku-list"></div>
</div>